import type { AdminUserRecord, UserType } from "@shared/types";
import { apiClient } from "@/lib/api-client";

export type { AdminUserRecord };

export async function listAdminUsers(
	filters: Record<string, string | number | boolean | undefined>,
) {
	const response = await apiClient.get("/api/v1/admin/users", {
		params: filters,
	});
	return response.data.data.users as AdminUserRecord[];
}

export async function getAdminUser(userId: string) {
	const response = await apiClient.get(`/api/v1/admin/users/${userId}`);
	return response.data.data.user as AdminUserRecord;
}

export async function suspendUser(userId: string, reason: string) {
	const response = await apiClient.post(
		`/api/v1/admin/users/${userId}/suspend`,
		{
			reason,
		},
	);
	return response.data.data.user;
}

export async function reactivateUser(userId: string, reason: string) {
	const response = await apiClient.post(
		`/api/v1/admin/users/${userId}/reactivate`,
		{
			reason,
		},
	);
	return response.data.data.user;
}

export async function changeUserType(
	userId: string,
	userType: UserType,
	reason: string,
) {
	const response = await apiClient.patch(`/api/v1/admin/users/${userId}/type`, {
		userType,
		reason,
	});
	return response.data.data.user;
}

export async function resendOtp(userId: string, reason?: string) {
	const response = await apiClient.post(
		`/api/v1/admin/users/${userId}/resend-otp`,
		{
			reason,
		},
	);
	return response.data.data;
}
